import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AcceptExternalTestLabScheduleRequest } from '../../../../../../../../core/projects.actions';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { ProjectsService } from '../../../../../../../../core/projects.service';

@Component({
    selector: 'app-external-test-schedule-details',
    templateUrl: './external-test-schedule-details.component.html',
    styleUrls: ['./external-test-schedule-details.component.scss'],
    standalone: false
})
export class ExternalTestScheduleDetailsComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store,
    private projectsService: ProjectsService,
  ) {
  }

  ngOnInit() {
    this.projectsService.changeView
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        if (data?.id) {
          this.data = data;
        }
      });
  }

  accept() {
    const payload = {
      testId: this.data.id,
    };
    this.store.dispatch(AcceptExternalTestLabScheduleRequest({ payload }));
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
